var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56231 7.36073C8.56231 9.84792 6.50324 11.8479 4.01605 11.6995C1.45996 11.547 -0.289639 9.08872 0.0398113 6.51917C0.239194 4.95631 0.971896 3.61609 1.76943 2.57636C1.90806 2.39492 2.05036 3.85502 2.19266 3.69437C2.33536 3.52924 3.65806 1.24021 4.11799 0.436154C4.13776 0.400689 4.16495 0.369897 4.19768 0.345869C4.23042 0.32184 4.26794 0.30514 4.30771 0.296901C4.34747 0.288662 4.38854 0.289078 4.42813 0.29812C4.46772 0.307163 4.5049 0.32462 4.53714 0.349306C5.46107 1.04653 8.56231 3.66542 8.56231 7.36073Z",
    fill: "#FF6723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33908 8.38481C7.33908 10.0329 5.90426 11.3576 4.15915 11.2977C2.27541 11.2341 0.983703 9.51016 1.26015 7.73447C1.65932 5.18857 4.27291 3.55273 4.27291 3.55273C4.27291 3.55273 7.33908 5.47195 7.33908 8.38481Z",
    fill: "#FFB02E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.7314211d40bc805b17228e0fd3bfcbf8.svg";
export { ForwardRef as ReactComponent };